module.exports = __webpack_public_path__ + "static/img/b300d35606d757f32947981f1a833c56_d8b6577172f64be3a7fdb9ba2652f66a.9fbf855.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/b300d35606d757f32947981f1a833c56_d8b6577172f64be3a7fdb9ba2652f66a.jpg
// module id = icgb
// module chunks = 1